import DataTableHeaderFilter from './DataTableHeaderFilter';

export default DataTableHeaderFilter;
